import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './layout/Layout';
import ChatbotPage from './views/ChatbotPage';
import DashboardPage from './views/DashboardPage';
import ChartsPage from './views/ChartsPage';
import TradersPage from './views/TradersPage';
import TestAPI from './TestAPI';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<ChatbotPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/charts" element={<ChartsPage />} />
          <Route path="/traders" element={<TradersPage />} />
          <Route path="/test" element={<TestAPI />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
